import { EnvironmentsName } from '@workspace/data-types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import pkg from '../../../../../../../../package.json';
import { EnvironmentConf } from './environment.interface';

const APP_NAME = 'etxe';
const domain = 'etxe.dev';
const environmentName = EnvironmentsName.TEST;

export const environment: EnvironmentConf = {
  name: environmentName,
  appName: APP_NAME,
  production: false,
  localhost: false,
  version: pkg.version,
  domain,
  allowedHosts: ['localhost', '127.0.0.1', domain, `*.${domain}`, `test.${domain}`, `*.test.${domain}`],
  apps: {
    adminUrl: `https://test.admin.${domain}`,
    ownerUrl: `https://test.${domain}/owner`,
    agentUrl: `https://test.${domain}/agent`,
    publicUrl: `https://test.${domain}`,
    zammadUrl: `https://zammad.pyzou.dev`,
  },
  auth: {
    keycloak: {
      host: `https://auth.pyzou.dev`,
      realm: {
        name: environmentName,
        clientId: `angular-sso`,
      },
    },
  },
  stripe: {
    publishableKey:
      'pk_test_51TP0yBI3d1Qv6vGay5zfrb05Zegv79ZFXV4goaB6lxcjItGEYAToAetOiSBDxPtUNRwC6AEOGMhbpbX12UcWeJ3G00LXkQk2W5',
    pricingTableId: 'prctbl_1TffLhI3d1Qv6vGaBIKo5JWW',
  },
};
